import React from "react";
import styles from "../blocks/Blocks.module.scss";
import Button from "../../../../components/Button/Button";
import Logo from "../../../../components/Logo/Logo";


const TextContent = ({
  sectionName,
  sectionNameCoBranding = false,
  title,
  subtitle,
  buttonText,
  nextPage,
  brand
}) => {
  return (
    <>
      <div className={styles.info}>
        {sectionName && (
          <div className={styles.sectionName}>
            <h4>{sectionName}</h4>
            {sectionNameCoBranding && (
              <>
                <span>✕</span>
                <Logo brand={brand} />
              </>
            )}
          </div>
        )}
        <h1>{title}</h1>
        <div dangerouslySetInnerHTML={{ __html: subtitle }}></div>
      </div>
      <Button onClick={nextPage} style={styles.button} community rounded>
        {buttonText}
      </Button>
    </>
  );
};

export default TextContent;
